import React from 'react';
import PropTypes from 'prop-types';

import WizardHeader from '../../../../components/WizardHeader/WizardHeader';

import withIntl from '../../../../lib/withIntl';

import {SerialDilutionStep} from '../../../../constants/dataEnum';

import './SerialDilutionHeader.scss';

function SerialDilutionHeader({
  step,
  onBack,
  onNext,
  onApplyEdit,
  onCancel,
  onFinish,
  disallowNext,
  disallowFinish,
  disallowApplayEdit,
  hideCancelButton,
  isEditing,
  intl,
}) {
  const getNextButton = () => {
    let button = intl.formatMessage({id: 'protocolEditor.serialDilution.header.continueButton'});

    if (step === SerialDilutionStep.SERIAL_DILUTION_SETTINGS) {
      button = intl.formatMessage({id: 'protocolEditor.serialDilution.header.finishButton'});
    }

    if (isEditing) {
      button = intl.formatMessage({id: 'protocolEditor.serialDilution.header.applyButton'});
    }

    return button;
  };

  const handleNextButton = () => {
    if (isEditing) {
      onApplyEdit();
      return;
    }

    if (step === SerialDilutionStep.SERIAL_DILUTION_SETTINGS) {
      onFinish();
      return;
    }

    onNext();
  };

  const renderText = () => {
    let title = '';
    let subtitle = '';

    if (step === SerialDilutionStep.SERIAL_DILUTION_SETTINGS) {
      title = intl.formatMessage({id: 'protocolEditor.serialDilution.header.serialDilutionSettings'});
    } else {
      title = intl.formatMessage({id: `protocolEditor.serialDilution.header.step${step}.title`});
      subtitle = intl.formatMessage({id: `protocolEditor.serialDilution.header.step${step}.subTitle`});
    }

    return (
      <span className="header-text">
        <span className="header-text-title">{title}</span>
        <span className="header-text-subtitle">{subtitle}</span>
      </span>
    );
  };

  return (
    <WizardHeader
      hideBackButton={!hideCancelButton}
      onBackClick={onBack}
      nextButtonText={getNextButton()}
      disableNextButton={
        step === SerialDilutionStep.SERIAL_DILUTION_SETTINGS
          ? disallowFinish
          : disallowNext || (isEditing && disallowApplayEdit)
      }
      onNextClick={handleNextButton}
      cancelButtonText={intl.formatMessage({id: 'protocolEditor.serialDilution.header.cancelButton'})}
      onCancelClick={onCancel}
      hideCancelButton={hideCancelButton}
    >
      {renderText()}
    </WizardHeader>
  );
}

SerialDilutionHeader.propTypes = {
  step: PropTypes.number,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  onApplyEdit: PropTypes.func,
  disallowNext: PropTypes.bool,
  onCancel: PropTypes.func,
  onFinish: PropTypes.func,
  disallowFinish: PropTypes.bool,
  hideCancelButton: PropTypes.bool,
  isEditing: PropTypes.bool,
  disallowApplayEdit: PropTypes.bool,
  intl: PropTypes.any.isRequired,
};

SerialDilutionHeader.defaultProps = {
  step: 1,
  onBack: () => {},
  onNext: () => {},
  onApplyEdit: () => {},
  disallowNext: false,
  onCancel: () => {},
  onFinish: () => {},
  disallowFinish: false,
  hideCancelButton: false,
  isEditing: false,
  disallowApplayEdit: false,
};

export default withIntl(SerialDilutionHeader);
